/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Dialog, DialogContent, DialogContentText, Stack } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "./Spinner";

export interface ConnectingDialogProps {
  open?: boolean;
}

export const ConnectingDialog: FC<ConnectingDialogProps> = ({
  open = true,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "30vw",
        },
      }}
    >
      <DialogContent
        sx={{
          "&.MuiDialogContent-root": {
            display: "flex",
            minHeight: "30vh",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          },
        }}
      >
        <Stack direction="column" spacing={2}>
          <Spinner />
          <DialogContentText>{t("AWVUI-MSG46")}</DialogContentText>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
